import { __assign } from 'tslib';
import { buttons } from './buttons.js';

var _a, _b;
var iconButtons = {
    base: __assign(__assign({}, buttons.base), { lineHeight: 0, padding: 0, width: "var(--button-size)", height: "var(--button-size)", fontSize: "var(--icon-size)", justifyContent: "center", alignItems: "center" }),
    variants: {
        look: __assign({}, (_a = buttons.variants) === null || _a === void 0 ? void 0 : _a.look),
        tone: __assign({}, (_b = buttons.variants) === null || _b === void 0 ? void 0 : _b.tone),
        size: {
            xs: {
                "--button-size": "26px",
                "--icon-size": "16px",
            },
            sm: {
                "--button-size": "33px",
                "--icon-size": "20px",
            },
            md: {
                "--button-size": "44px",
                "--icon-size": "24px",
            },
            lg: {
                "--button-size": "56px",
                "--icon-size": "32px",
            },
            inherit: {
                "--button-size": "100%",
                "--icon-size": "inherit",
            },
            auto: {
                "--button-size": "fit-content",
                "--icon-size": "inherit",
            },
        },
        rounded: {
            true: {
                borderRadius: "100%",
            },
        },
    },
    variantOrder: buttons.variantOrder,
};

export { iconButtons };
//# sourceMappingURL=icon-buttons.js.map
